var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7982 101C43.0902 101 50.6315 93.4588 50.6315 84.1668V67.3335H33.7982C24.5062 67.3335 16.9648 74.8748 16.9648 84.1668C16.9648 93.4588 24.5062 101 33.7982 101Z",
    fill: "#0ACF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9648 50.4998C16.9648 41.2078 24.5062 33.6665 33.7982 33.6665H50.6315V67.3332H33.7982C24.5062 67.3332 16.9648 59.7918 16.9648 50.4998Z",
    fill: "#A259FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9648 16.8333C16.9648 7.54133 24.5062 0 33.7982 0H50.6315V33.6667H33.7982C24.5062 33.6667 16.9648 26.1253 16.9648 16.8333Z",
    fill: "#F24E1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6315 0H67.4649C76.7569 0 84.2982 7.54133 84.2982 16.8333C84.2982 26.1253 76.7569 33.6667 67.4649 33.6667H50.6315V0Z",
    fill: "#FF7262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2982 50.4998C84.2982 59.7918 76.7569 67.3332 67.4649 67.3332C58.1729 67.3332 50.6315 59.7918 50.6315 50.4998C50.6315 41.2078 58.1729 33.6665 67.4649 33.6665C76.7569 33.6665 84.2982 41.2078 84.2982 50.4998Z",
    fill: "#1ABCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/Figma.11aec93db76d1bbd708a1a46bb919b81.svg";
export { ForwardRef as ReactComponent };